"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var InfoBarMessageWithCustomAction = function (props) {
    var customActionClickHandler = function (action) {
        return function (evt) {
            evt.stopPropagation();
            action();
        };
    };
    return (React.createElement("a", { className: props.className, onClick: customActionClickHandler(props.customAction.action) }, props.customAction.text));
};
exports.default = InfoBarMessageWithCustomAction;
//# sourceMappingURL=InfoBarMessageWithCustomAction.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-info-bar/lib/components/InfoBarMessageWithCustomAction.js
// module id = 3108
// module chunks = 3 4 17